export default __webpack_public_path__ + "static/media/logo_borderless.8247c365.svg";